export default __webpack_public_path__ + "static/media/choose-us-03.1453ce72.svg";